<template>
  <div v-if="showCategories">
    <div class="categories-filter__section-title">
      <h4>Coleções disponíveis</h4>
    </div>

    <div class="categories-filter__categories-container">
      <div
        ref="categoriesContainer"
        :class="[
          'categories-filter__categories',
          { 'categories-filter__categories--mobile': isMobile },
        ]"
        :style="categoriesToShow.length ? containerStyle : {}"
      >
        <transition name="fade">
          <div>
            <circular-skeleton-loading
              v-if="!categoriesToShow.length"
              :skeleton-count="18"
              :is-mobile="isMobile"
              :margin="computedMargin"
              :style="{ paddingTop: '10px' }"
            />
            <button
              v-for="category in categoriesToShow"
              :key="category.id"
              :class="[
                'categories-filter__categories-circle-item',
                {
                  'categories-filter__categories-circle-item--active': isCategorySelected(
                    category
                  ),
                },
              ]"
              :style="{ marginRight: computedMargin + 'px' }"
              @click="onSelectCategory(category)"
            >
              <div
                class="circle-icon"
                :class="{
                  dimmed:
                    hasSelectedTopLevelCategory &&
                    !isCategorySelected(category),
                }"
              >
                <img
                  v-if="getCategoryImage(category)"
                  :src="getCategoryImage(category)"
                  loading="lazy"
                  alt="icon"
                />
              </div>
              <span
                class="category-name"
                :class="{
                  dimmed:
                    hasSelectedTopLevelCategory &&
                    !isCategorySelected(category),
                }"
                >{{ category.name }}</span
              >
            </button>
          </div>
        </transition>
      </div>

      <div v-if="shouldShowArrows" class="categories-filter__nav">
        <button
          class="categories-filter__nav-item categories-filter__nav-item--left"
          :class="{ 'categories-filter__nav-item--hide': shouldHideLeftArrow }"
          @click="navGallery(1)"
        >
          <ArrowLeft class="categories-filter__arrow" />
        </button>
        <button
          class="categories-filter__nav-item categories-filter__nav-item--right"
          @click="navGallery(-1)"
        >
          <ArrowRight class="categories-filter__arrow" />
        </button>
      </div>
    </div>

    <CategoriesChildrenRow
      :children-to-show="childrenToShow"
      :is-mobile="isMobile"
      :selected-categories="selectedCategories"
      @select-category="onSelectCategory"
      @back-to-grand-parent="onBackToGrandParent"
    />
  </div>
</template>

<script>
import CircularSkeletonLoading from '@/components/loadings/skeleton/CircularSkeletonLoading.vue'
import CategoriesChildrenRow from '@/components/new-catalog/CategoriesChildrenRow.vue'
import ArrowLeft from '~/components/icons/arrow-left/ArrowLeft'
import ArrowRight from '~/components/icons/arrow-right/ArrowRight'
import scrollingNavigator from '~/mixins/scrolling-navigator'

export default {
  name: 'CircularCategoriesFilter',
  components: {
    CircularSkeletonLoading,
    ArrowLeft,
    ArrowRight,
    CategoriesChildrenRow,
  },
  mixins: [scrollingNavigator],
  props: {
    categoriesToShow: { type: Array, default: () => [] },
    childrenToShow: { type: Array, default: () => [] },
    selectedCategory: { type: Object, default: null },
    selectedCategories: { type: Array, default: () => [] },
    showCategories: { type: Boolean, default: true },
    isMobile: { type: Boolean, default: false },
    listClassName: { type: String, default: 'categories-filter__categories' },
  },
  data() {
    return {
      translateX: 0,
      initialTranslate: 0,
      itemWidth: 50,
      halfItemWidth: 25,
      computedMargin: 30,
      visibleCount: 0,
      leftPadding: 10,
      categoriesItems: [
        {
          id: 722,
          name: 'Minimalista',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/56730832415840171745609651407.png?tr=w-100',
        },
        {
          id: 349,
          name: 'Futebol',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/30786770931710041745609061772.png?tr=w-100',
        },
        {
          id: 33,
          name: 'Para Eles',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/305641997918180141745609901329.png?tr=w-100',
        },
        {
          id: 327,
          name: 'Produtos Disney',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/313344612402826961745608933345.png?tr=w-100',
        },
        {
          id: 4502,
          name: 'Fontes',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/378509207155962261745609006599.png?tr=w-100',
        },
        {
          id: 717,
          name: 'Florais',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/95229302588978671745608988109.png?tr=w-100',
        },
        {
          id: 718,
          name: 'Sua Foto',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/50101624620641961743465016588.png?tr=w-100',
        },
        {
          id: 725,
          name: 'Religião',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/283430078014013761745610167363.png?tr=w-100',
        },
        {
          id: 716,
          name: 'Animais',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/76289733612895651745608658126.png?tr=w-100',
        },
        {
          id: 6703,
          name: 'Borboletas',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/0130924653767630071745608781902.png?tr=w-100',
        },
        {
          id: 443,
          name: 'Marvel',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/439976219159969761745609582454.png?tr=w-100',
        },
        {
          id: 55,
          name: 'Viagem',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/76649432654240921745611144048.png?tr=w-100',
        },
        {
          id: 732,
          name: 'Warner',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/19207934528044081745611201516.png?tr=w-100',
        },
        {
          id: 2072,
          name: 'Esportes',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/76890740303640711745608968872.png?tr=w-100',
        },
        {
          id: 4072,
          name: 'Senna Collection',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/305641997918180141745609901329.png?tr=w-100',
        },
        {
          id: 2993,
          name: 'Korean Wave',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/218055041751754271745609248037.png?tr=w-100',
        },
        {
          id: 720,
          name: 'Namorados',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/53280735043971961745609713210.png?tr=w-100',
        },
        {
          id: 3512,
          name: 'Harry Potter',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/84761340786936681745609136715.png?tr=w-100',
        },
        {
          id: 3083,
          name: 'Coquette',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/484858051394023161745608863595.png?tr=w-100',
        },
        {
          id: 1428,
          name: 'Meu Pet',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/4479079588919551745610002293.png?tr=w-100',
        },
        {
          id: 858,
          name: 'Profissões',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/201222271741735131745610145420.png?tr=w-100',
        },
        {
          id: 715,
          name: 'Crie seu Personagem',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/14205778267175551745608898375.png?tr=w-100',
        },
        {
          id: 750,
          name: 'Naruto',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/192996176190541771745609738040.png?tr=w-100',
        },
        {
          id: 470,
          name: 'Star Wars',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/38663249508023891745610238918.png?tr=w-100',
        },
        {
          id: 3316,
          name: 'Gatos',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/46433177845027151745609098614.png?tr=w-100',
        },
        {
          id: 767,
          name: 'NBA',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/396042505676761745609791087.png?tr=w-100',
        },
        {
          id: 2190,
          name: 'Van Gogh',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/04800275331451521745610272305.png?tr=w-100',
        },
        {
          id: 3151,
          name: 'Japanese Culture',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/0177614824224205941745609216277.png?tr=w-100',
        },
        {
          id: 3742,
          name: 'Pop Icons',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/51752327011867691745610058908.png?tr=w-100',
        },
        {
          id: 5128,
          name: 'Snoopy',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/67321689159427691745610224016.png?tr=w-100',
        },
        {
          id: 721,
          name: 'Universo',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/123142906099974581745610257040.png?tr=w-100',
        },
        {
          id: 3676,
          name: 'Sanrio',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/86262000922402351745610192457.png?tr=w-100',
        },
        {
          id: 2000,
          name: 'Paramount',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/92555688520774371745609920802.png?tr=w-100',
        },
        {
          id: 3247,
          name: 'Pattern',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/325618554191087761745609983797.png?tr=w-100',
        },
        {
          id: 6705,
          name: '10 Anos',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/110507992042363061745608565771.png?tr=w-100',
        },
        {
          id: 6768,
          name: 'K-pop',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/233067502427771521745609268429.png?tr=w-100',
        },
        {
          id: 1416,
          name: 'Pride',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/58734390402964791745610097911.png?tr=w-100',
        },
        {
          id: 6706,
          name: 'Bob Esponja',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/303740190394086731745608714438.png?tr=w-100',
        },
        {
          id: 5788,
          name: 'Mattel',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/80598732047655691745609619657.png?tr=w-100',
        },
        {
          id: 4667,
          name: 'Full Print',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/72493406258986451743478454606.png?tr=w-100',
        },
        {
          id: 25,
          name: 'Frases',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/58948299824642581745609024461.png?tr=w-100',
        },
        {
          id: 3618,
          name: 'Art Gallery',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/79975958218858391745608676173.png?tr=w-100',
        },
        {
          id: 6701,
          name: 'Carnaval',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/069934697210435661745608824534.png?tr=w-100',
        },
        {
          id: 4240,
          name: 'Brasilcore',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/64218768911044791745608805506.png?tr=w-100',
        },
        {
          id: 5920,
          name: 'Patrulha Canina',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/71951303472011341745609961123.png?tr=w-100',
        },
        {
          id: 6652,
          name: 'Coleção Muito Eu',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/84366506315817421745609665593.png?tr=w-100',
        },
        {
          id: 1041,
          name: 'DC Comics',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/95358503080203141745608916045.png?tr=w-100',
        },
        {
          id: 1373,
          name: 'Signos',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/67005749373796291745610209567.png?tr=w-100',
        },
        {
          id: 6687,
          name: 'Book Lover',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/54357636866297241745608764009.png?tr=w-100',
        },
        {
          id: 255,
          name: 'Amizade',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/92077982220391861745608640609.png?tr=w-100',
        },
        {
          id: 2013,
          name: 'NFL',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/73168095609905341745609865842.png?tr=w-100',
        },
        {
          id: 6217,
          name: 'Barbie',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/52073620274353621745608697285.png?tr=w-100',
        },
        {
          id: 765,
          name: 'Positividade',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/23986027832206481745610076852.png?tr=w-100',
        },
        {
          id: 798,
          name: 'Mar',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/9089630515072191745609297786.png?tr=w-100',
        },
        {
          id: 27,
          name: 'Música',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/87510127158895411745609690295.png?tr=w-100',
        },
        {
          id: 3876,
          name: 'Jujutsu Kaisen',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/85518763794343321745609232051.png?tr=w-100',
        },
        {
          id: 597,
          name: 'Coloridas',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/66277067091029421745608842835.png?tr=w-100',
        },
        {
          id: 3619,
          name: 'Cowgirl',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/176281158336863641745608880286.png?tr=w-100',
        },
        {
          id: 2171,
          name: 'Artistas',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/35633151582615121745611178603.png?tr=w-100',
        },
        {
          id: 2071,
          name: 'Games',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/91524903975101751745609081955.png?tr=w-100',
        },
        {
          id: 3513,
          name: 'Friends',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/82348990079693911745609044672.png?tr=w-100',
        },
        {
          id: 1861,
          name: 'Halloween',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/134976744134990171745609116070.png?tr=w-100',
        },
        {
          id: 6613,
          name: 'Hotwheels',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/232582244328632061743478408878.png?tr=w-100',
        },
        {
          id: 4503,
          name: 'Colagem',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/6314753445651411743478147982.png?tr=w-100',
        },
        {
          id: 1039,
          name: 'Viral',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/67608350697848441745611161608.png?tr=w-100',
        },
        {
          id: 908,
          name: 'Natal',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/66265561093510471745609772093.png?tr=w-100',
        },
        {
          id: 743,
          name: 'Netflix',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/334134832224491141745609821659.png?tr=w-100',
        },
        {
          id: 1409,
          name: 'Embaixadoras',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/94636346185243781745608950122.png?tr=w-100',
        },
        {
          id: 2080,
          name: 'Inteligência Artificial',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/223612138362009441745609194241.png?tr=w-100',
        },
        {
          id: 3511,
          name: 'Abril Azul',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/251841296155530751745608623918.png?tr=w-100',
        },
        {
          id: 2290,
          name: 'Pink Core',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/86150694754607391745610043390.png?tr=w-100',
        },
        {
          id: 4435,
          name: 'Parintins',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/203927950818246441745609939240.png?tr=w-100',
        },
        {
          id: 2172,
          name: 'Parcerias',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/44805828887440171745609341972.png?tr=w-100',
        },
        {
          id: 2455,
          name: 'Self Love',
          image:
            'https://ik.imagekit.io/gocase/engines/qr-img/56128330588328421743475212360.png?tr=w-100',
        },
      ],
    }
  },
  computed: {
    shouldShowArrows() {
      return !this.isMobile && this.categoriesToShow.length
    },
    shouldHideLeftArrow() {
      return !this.translateX || this.translateX === 0 || this.isMobile
    },
    isCategorySelected() {
      return (category) =>
        this.selectedCategories.some((cat) => cat.id === category.id)
    },
    hasSelectedTopLevelCategory() {
      return this.categoriesToShow.some((category) =>
        this.selectedCategories.some((sel) => sel.id === category.id)
      )
    },
    containerStyle() {
      return {
        paddingLeft: this.leftPadding + 'px',
        paddingRight: this.halfItemWidth + 'px',
      }
    },
  },
  watch: {
    selectedCategory() {
      this.$nextTick(() => {
        this.autoScrollToSelectedCategory({
          refName: 'categoriesContainer',
          isMobile: this.isMobile,
          activeSelector: '.categories-filter__categories-circle-item--active',
          offset: this.isMobile ? 18 : 70,
        })
      })
    },
    categoriesToShow(newVal) {
      if (newVal.length) {
        this.$nextTick(() => {
          this.calculateLayout()
          this.autoScrollToSelectedCategory({
            refName: 'categoriesContainer',
            isMobile: this.isMobile,
            activeSelector:
              '.categories-filter__categories-circle-item--active',
            offset: this.isMobile ? 18 : 70,
          })
        })
      }
    },
  },
  mounted() {
    this.initialTranslate = this.translateX
    this.calculateLayout()
    window.addEventListener('resize', this.calculateLayout)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateLayout)
  },
  methods: {
    onSelectCategory(category) {
      this.$emit('select-category', category)
    },
    onBackToGrandParent() {
      this.$emit('back-to-grand-parent', this.selectedCategory)
    },
    calculateLayout() {
      this.$nextTick(() => {
        const container = this.$refs.categoriesContainer
        if (!container) return
        const W = container.clientWidth
        const L = this.leftPadding

        // RTarget: área reservada para o próximo item; halfItemWidth (25px)
        const RTarget = this.halfItemWidth
        const I = this.itemWidth

        // Menor baseMargin para caber mais itens
        const baseMargin = 20

        // Calcula quantos itens completos cabem reservando RTarget no final
        let n = Math.floor((W - L - RTarget) / (I + baseMargin))
        if (n < 1) n = 1

        // Ajusta o espaçamento M:
        // L + n*(I + M) = W - RTarget  ==>  M = ((W - L - RTarget)/n) - I
        const M = (W - L - RTarget) / n - I
        this.computedMargin = M
        this.visibleCount = n
      })
    },
    getCategoryImage(category) {
      const found = this.categoriesItems.find((item) => item.id === category.id)
      return found && found.image ? found.image : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.categories-filter {
  &__section-title {
    margin-top: 4px;
    margin-bottom: 10px;
    h4 {
      font-weight: 500;
      font-size: 15px;
    }
  }

  &__categories-container {
    position: relative;
    overflow: hidden;
    margin-bottom: -10px;
  }

  &__categories {
    overflow: visible;
    white-space: nowrap;
    transition: transform 400ms cubic-bezier(0.165, 0.84, 0.44, 1);
    padding-bottom: 10px;
    min-height: 65px;

    &--mobile {
      overflow: auto;
    }

    &-circle-item {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      text-align: center;
      width: 50px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 3px;
      margin-bottom: -2px;
      transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;

      .circle-icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid $v4_color_primary;
        background: $color-background-gray;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .category-name {
        font-weight: bold;
        color: inherit;
        font-size: 11px;
        white-space: normal;
        word-wrap: break-word;
        overflow-wrap: break-word;
        margin-bottom: 0;
      }

      &:hover {
        .circle-icon {
          background: $v4_color_primary_light;
        }
      }

      &--active {
        .circle-icon {
          background: $v4_color_primary_light;
        }
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }

  &__nav {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    transform: translateY(-100%);
    display: flex;
    justify-content: space-between;
    pointer-events: none;

    &-item {
      pointer-events: all;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 0;
      background-color: $color-light-gray-transparent;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 5px;

      &:hover {
        background-color: $color-light-gray;
      }

      &--left {
        margin-left: 2px;
      }

      &--right {
        margin-right: 2px;
      }

      &--hide {
        opacity: 0;
      }

      .categories-filter__arrow {
        width: 20px;
        fill: $v4_color_blue;
        transition: all 0.2s ease-in-out;
      }
    }
  }
}

.dimmed {
  opacity: 0.4;
  filter: brightness(0.9);
  transition: opacity 0.3s ease-in-out, filter 0.3s ease-in-out;
}
</style>
